'use client';
import Section from '@repo/ui/src/components/Section';
import { AlignH } from '@repo/ui/src/types/general';
import { ToutContent } from '@repo/ui/src/components/ToutContent/_toutContent';
import { useIsMD } from '@repo/ui/src/utils/useMediaQuery';

interface Props {
  darkMode: boolean;
  useTexture: boolean;
  heading: string;
  headerVariation: any;
  headerAlign: AlignH;
  leftColumn: string;
  leftColumnAlign: AlignH;
  rightColumn: string;
  rightColumnAlign: AlignH;
  className?: string;
}

export const TitledSplitToutContent = ({
  darkMode,
  useTexture,
  heading,
  headerVariation,
  headerAlign,
  leftColumn,
  leftColumnAlign,
  rightColumn,
  rightColumnAlign,
  className,
}: Props) => {
  const mdAndUp = useIsMD();
  const computedHeaderAlign = mdAndUp ? headerAlign || 'center' : 'left';

  return (
    <div className={className}>
      <Section dark={darkMode} texture={useTexture} gutterX basePadding gutterY>
        <div className="tw-grid tw-grid-cols-12 tw-gap-x-4">
          {/* Top divider */}
          <div className="tw-col-span-12 tw-mb-6 after:tw-content-[''] after:tw-block after:tw-h-2 after:tw-w-20 after:tw-bg-brand-300 after:tw-mx-auto" />

          {/* Heading section */}
          <div className="tw-hidden md:tw-block md:tw-col-span-2" />
          <div className="tw-col-span-12 md:tw-col-span-8 tw-py-4 md:tw-pb-12 max-md:tw-pb-4">
            <ToutContent
              dark={darkMode}
              heading={heading}
              headerVariation={headerVariation || 'h2'}
              headingStyleVariant="h1"
              align={computedHeaderAlign}
            />
          </div>
          <div className="tw-hidden md:tw-block md:tw-col-span-2" />

          {/* Left and Right columns */}
          <div className="tw-hidden md:tw-block md:tw-col-span-2" />
          <div className="tw-col-span-12 md:tw-col-span-4 tw-pb-4 md:tw-pr-3 max-md:tw-pr-0">
            <ToutContent
              dark={darkMode}
              headingLight={leftColumn}
              headingStyleVariant="h3"
              align={leftColumnAlign || 'left'}
              fullWidth
            />
          </div>
          <div className="tw-col-span-12 md:tw-col-span-4 tw-pb-4 md:tw-pl-3 max-md:tw-pl-0">
            <ToutContent
              dark={darkMode}
              description={rightColumn}
              align={rightColumnAlign || 'left'}
              fullWidth
            />
          </div>
          <div className="tw-hidden md:tw-block md:tw-col-span-2" />

          {/* Bottom divider */}
          <div className="tw-col-span-12 tw-mt-6 after:tw-content-[''] after:tw-block after:tw-h-2 after:tw-w-20 after:tw-bg-brand-300 after:tw-mx-auto" />
        </div>
      </Section>
    </div>
  );
};

export default TitledSplitToutContent;
